export default __webpack_public_path__ + "static/media/triton.e20b28e7.jpg";